<template>
  <base-select inset :options="options" expand v-model="selected" @change="$emit('change')"></base-select>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    value: null,
  },
  emits: ['input', 'change'],
  data() {
    return {
      officeExpeditons: {
        data: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    options() {
      return [
        {
          key: 'null',
          label: 'Pilih Ekspedisi',
          value: null,
        },
        ...this.officeExpeditons.data.map((officeExpediton) => ({
          key: officeExpediton.id,
          label: `${officeExpediton.attributes.code} - ${officeExpediton.attributes.name}`,
          value: officeExpediton.id,
        })),
      ];
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async loadOfficeExpeditions() {
      const [res, err] = await this.request(
        `/api/v1/offices/${this.me.office_id}/office-expeditions`
      );

      if (!err) {
        this.officeExpeditons = res;
      }
    },
  },
  created() {
    this.loadOfficeExpeditions();
  },
};
</script>
